import React, { useState } from "react";
import { UserIconTwo } from "../Icons";
import { Outlet } from "react-router-dom";
export default function EBCompaniesWrapper({ Nav }) {
  const [metaData, setMetaData] = useState({
    stat1: {
      value: 0,
      label: "Total partners"
    },
    stat2: {
      value: 0,
      label: "Total verified"
    },
    stat3: {
      value: 0,
      label: "Total unverified"
    }
  })

  return (
    <main className="invoice-wrapper">
      <section className=" stats mb-3">
        <div className="stat" style={{ borderLeft: "7px solid #2463ae" }}>
          <div className="icon bg-light-blue text-primary">
            <UserIconTwo />
          </div>
          <div className="details">
            <p>{metaData.stat1?.value || 0}</p>
            <span>{metaData.stat1?.label || ""}</span>
          </div>
        </div>
        <div className="stat" style={{ borderLeft: "7px solid green" }}>
          <div className="icon bg-light-blue">
            <UserIconTwo fill="green" />
          </div>
          <div className="details">
            <p>{metaData.stat2?.value || 0}</p>
            <span>{metaData.stat2?.label || ""}</span>
          </div>
        </div>
        <div className="stat" style={{ borderLeft: "7px solid orange" }}>
          <div className="icon bg-light-blue">
            <UserIconTwo fill="orange" />
          </div>
          <div className="details">
            <p>
              {metaData.stat3?.value || 0}
            </p>
            <span>{metaData.stat3?.label || ""}</span>
          </div>
        </div>
      </section>

      {Nav && <div className="nav-bar">{Nav}</div>}
      <Outlet context={ setMetaData } />
    </main>
  );
}
